import { render } from "./CreateTimeslotModal.vue?vue&type=template&id=57770964&scoped=true"
import script from "./CreateTimeslotModal.vue?vue&type=script&lang=js"
export * from "./CreateTimeslotModal.vue?vue&type=script&lang=js"

import "./CreateTimeslotModal.vue?vue&type=style&index=0&id=57770964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57770964"]])

export default __exports__